import { configureStore } from "@reduxjs/toolkit";

import agentReducer from "../slices/agentSlice";
import contactFormReducer from "../slices/contactFormSlice";
import uiReducer from "../slices/uiSlice";

export default services =>
  configureStore({
    reducer: {
      agent: agentReducer,
      ui: uiReducer,
      contactForm: contactFormReducer
    },
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: services
        },
        serializableCheck: false
      })
  });
